import { Disclaimer } from "pages/Application/Recommendation/Recommendation.styles"
import React from "react"
import styled from "styled-components"

export interface RecommendationDisclaimerProps {
  freeLegals?: boolean
}

const Grey = styled.span`
  color: #3b4258;
`

export const RecommendationDisclaimer = ({ freeLegals = false }: RecommendationDisclaimerProps) => {
  return (
    <Disclaimer>
      <Grey>
        <b>Representative example:</b> a repayment mortgage amount of £325,000 over 25 years,
        representative APRC 7%. Total amount payable £691,363.52 includes interest of £365,264.52
        product fees of £999 and other fees of £100. Repayments: 26 months of £1,757.01 at 4.23%
        (fixed), then 274 months of £2,352.49 at 7.49% (variable). Early repayment charges apply.
      </Grey>
      <Grey>
        * Data taken using Mojo’s internal records, covering the period from 18 February 2025 to 30
        September 2025. Average savings over the initial term based on the difference between the
        customer’s initial pay rate and their new, lower rate discovered through our Rate Check
        Promise service.
      </Grey>
      {freeLegals && <span>*There may additional charges for non-standard transaction.</span>}
      <span>
        Mojo is a trading style of Life's Great Limited which is registered in England and Wales
        (06246376). We are authorised and regulated by the Financial Conduct Authority and are on
        the Financial Services Register (478215){" "}
      </span>
      <span>Our registered office is The Cooperage, 5 Copper Row, London, SE1 2LH.</span>
      <span>To contact us by phone, please call 0333 123 0012.</span>
      <span>
        <b>
          YOUR HOME/PROPERTY MAY BE REPOSSESSED IF YOU DO NOT KEEP UP REPAYMENTS ON YOUR MORTGAGE
        </b>
      </span>
    </Disclaimer>
  )
}
